import { Component, EventEmitter, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take, takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../../../../helper/translation/anessa-translation.service';
import { DeactivationDialogService } from '../../../../helper/can-deactivate/deactivation-dialog.service';
import { Feedstock } from '../../../../models/project/feedstock/feedstock.model';
import { FinancialFeeType } from '../../../../models/project/financial/financial-fee-type.enum';
import { UserpilotReloader } from '../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-edit-feedstock-financial-dialog',
  templateUrl: './edit-feedstock-financial-dialog.component.html',
  styleUrls: [
    './edit-feedstock-financial-dialog.component.scss',
  ]
})
export class EditFeedstockFinancialDialogComponent extends UserpilotReloader implements OnInit, OnDestroy {
  onDestroyNotifier = new EventEmitter();
  /** trigger for translation pipe */
  trigger: string;

  @ViewChild('feedstockForm') feedstockForm: NgForm;

  feedstock: Feedstock;
  feeTypes = [
    { name: 'FEE_TYPE.free', value: FinancialFeeType.FREE },
    { name: 'FEE_TYPE.tipping_fee', value: FinancialFeeType.TIPPING_FEE },
    { name: 'FEE_TYPE.cost', value: FinancialFeeType.COST },
  ];
  FinancialFeeType = FinancialFeeType;

  constructor(
    private dialogRef: MatDialogRef<EditFeedstockFinancialDialogComponent>,
    private dialogService: DeactivationDialogService,
    public translationService: AnessaTranslationService,
    @Inject(MAT_DIALOG_DATA) private data: { feedstock: Feedstock },
  ) {
    super();
    if (data) {
      this.feedstock = this.data.feedstock;
    }
  }

  ngOnInit() {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.trigger = this.translationService.getCurrentLang();
      });

    this.dialogRef.backdropClick().subscribe(() => {
      if (this.feedstockForm && this.feedstockForm.dirty) {
        this.dialogService.confirm(this.translationService.get('PROJECT.COMMON.DEACTIVATE_CONFIRM'))
          .pipe(take(1)).subscribe((result: boolean) => {
            if (result) {
              this.dialogRef.close();
            }
          });
      } else {
        this.dialogRef.close();
      }
    });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  onSaveClick() {
    this.dialogRef.close(this.feedstock);
  }

  onCancelClick() {
    this.dialogRef.close(null);
  }
}
